export const normalizeEmail = (email) => (email ? email.trim().toLowerCase() : '');

/**
 * Utility functions for determining token visibility in buy/sell interface
 */

/**
  * Checks if a token should be visible in the buy/sell interface
  * @param {Object} token - The token object to check
  * @returns {boolean} - True if the token should be visible, false otherwise
  */
export const isTokenVisibleOnBuySell = (token) => {
  if (!token) {
    return false;
  }

  return token?.hideFromBuySell !== true;
};

/**
  * Checks if the current user is on the token's convert whitelist
  * @param {Object} token
  * @param {string} userEmail
  */
export const isTokenVisibleInConvert = (token, userEmail) => {
  if (!token) {
    return false;
  }

  const allowedEmails = Array.isArray(token.convertEmailWhitelist)
    ? token.convertEmailWhitelist
    : [];

  if (allowedEmails.length === 0) {
    return true;
  }

  const normalizedUserEmail = normalizeEmail(userEmail);
  return allowedEmails.some(
    (allowed) => normalizeEmail(allowed) === normalizedUserEmail
  );
};

export const getEmailFromStorage = () => {
  const storedEmail = localStorage.getItem('email') || localStorage.getItem('user');
  return normalizeEmail(storedEmail);
};
